import { Ajax, handler1 } from '../utils/wapperAjax';
const qs = require('qs');

// 仅用于测试登录
// TODO
// if (process.env.NODE_ENV == 'development') {
//   console.log('development');
//   Ajax.post('/site/login', {
//     uname: 18888888888,
//     // uname: 19999999999,
//     hash: 'e10adc3949ba59abbe56e057f20f883e',
//     remember: 1
//   });
// }
// end

function handleFormData(data) {
  let formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  return formData;
}

function handleData(type, data) {
  if (!data) {
    return;
  }
  if (type == 'folder') {
    data.name = data.folderName;
    data.id = data.folderId;
    data.type = 'folder';
    data.num = data.documentCount;
  } else {
    data.name = data.docName;
    data.id = data.docId;
    data.type = 'paper';
    data.num = data.paperCount;
  }
}

export function apiGetWebUser() {
  return handler1(Ajax.get('/web/user'));
}

export function apiGetWebPaper(data, opt) {
  return handler1(
    Ajax.get('/web/paper', {
      params: data
    }),
    opt
  );
}

// https://www.showdoc.cc/8109?page_id=880022646929117
export function apiGetWebSearch(data) {
  return handler1(
    Ajax.get('/web/search', {
      params: data
    })
  ).then((res) => {
    res.folder.forEach((v) => handleData('folder', v));
    res.document.forEach((v) => handleData('paper', v));
    return res;
  });
}

/**
 * 文档列表数据
 * @export
 * @param {Object} { folderId }
 * @returns
 */
export function apiGetWebDocument(data) {
  return handler1(
    Ajax.get('/web/document', {
      params: data
    })
  ).then((res) => {
    res.list.forEach((v) => handleData('paper', v));
    return res;
  });
}

/**
 * OCR结果查看
 * @export
 * @param {Object} { paperId }
 * @returns
 */
export function apiGetWebOcr(data) {
  return handler1(
    Ajax.get('/web/ocr', {
      params: data
    })
  );
}

/**
 * 文件夹列表数据
 * @export
 * @param {Object} { folderId }
 * @returns
 */
export function apiGetWebFolder(data) {
  return handler1(
    Ajax.get('/web/folder', {
      params: data
    })
  ).then((res) => {
    res.list.forEach((v) => handleData('folder', v));
    return res;
  });
}

/**
 * ocr支持的语言
 * @export
 * @param {Object} { lang:'zh' or 'en' }
 * @returns
 */
export function apiGetOcrLang(data) {
  return handler1(
    Ajax.get('/ocr/lang', {
      params: data
    })
  );
}

export function apiDeletePaper(data) {
  return handler1(
    Ajax.get('/ocr/lang', {
      params: data
    })
  );
}

export function apiRenamePage(data) {
  return handler1(
    Ajax.get('/ocr/lang', {
      params: data
    })
  );
}
export function apiRenamePaper(data) {
  return handler1(
    Ajax.get('/ocr/lang', {
      params: data
    })
  );
}

export function apiTrashPaper(data) {
  return handler1(
    Ajax.get('/trash/paper', {
      params: data
    })
  );
}

export function apiTrashDocument(data) {
  return handler1(
    Ajax.get('/trash/document', {
      params: data
    })
  );
}

export function apiTrashFolder(data) {
  return handler1(
    Ajax.get('/trash/folder', {
      params: data
    })
  );
}

// https://www.showdoc.cc/8109?page_id=4073720934742036
export function apiUpdatePaper(data) {
  return handler1(
    Ajax.post('/web/update/paper', data, {
      headers: { 'Content-Type': 'application/json' },
      _dataType: 'json'
    })
  );
}

export function apiUpdateDoc(data) {
  return handler1(
    Ajax.post('/web/update/document', data, {
      headers: { 'Content-Type': 'application/json' },
      _dataType: 'json'
    })
  );
}

export function apiUpdateFoloder(data) {
  return handler1(
    Ajax.post('/web/update/folder', data, {
      headers: { 'Content-Type': 'application/json' },
      _dataType: 'json'
    })
  );
}

export function apiRemoveFile(data) {
  return handler1(
    Ajax.post('/web/remove', data, {
      _dataType: 'json',
      headers: { 'Content-Type': 'application/json' }
    })
  );
}

export function apiDownloadShareFile(data) {
  return handler1(Ajax.post(`/share/pdf`, data));
}

export function apiDownloadFile(data) {
  return handler1(
    Ajax.get(`/web/${data.fileType}`, {
      params: {
        docId: data.docId
      }
    })
  );
}

// https://www.showdoc.cc/8109?page_id=4073666599540180
export function apiCreateFolder(data) {
  return handler1(Ajax.post('/web/create/folder', data), {
    limit_action: 'create_folder'
  }).then((res) => {
    handleData('folder', res);
    return res;
  });
}

export function apiUploadPdf(data, lang) {
  return handler1(
    Ajax.post('/web/upload/pdf?lang=' + lang, handleFormData(data), {
      _dataType: 'file',
      headers: { 'Content-Type': 'application/json' }
    })
  ).then((res) => {
    handleData('doc', res);
    return res;
  });
}

// 退出登录
export function apiLogout() {
  return handler1(Ajax.post('/site/logout'));
}

// 分享文档提取
export function apiShareExtraction(data) {
  return handler1(Ajax.post('/share/extraction', data), {
    noHandler: true
  });
}

// 分享文档保存
// https://www.showdoc.com.cn/8109?page_id=4665609962762651
export function apiShareSave(data) {
  return handler1(Ajax.post('/share/save', data));
}
